import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useEffect, useRef, useState } from 'react';
import { useDimensionsDetector, useClickOutsideCallback } from '../hooks';
import DefaultTheme from './theme';
import SmTheme from './theme/shipamall';
export var TooltipTheme = DefaultTheme;
export var ShipaMallTheme = SmTheme;
/*::
import type { Node, ElementRef, ElementType, Ref } from 'react';
import type { FlattenSimpleInterpolation } from 'styled-components';

import type { TooltipThemeType } from './theme';

export type TooltipPosition = 'top' | 'right' | 'bottom' | 'left';

export type Props = {|
  visible?: boolean,
  tooltipPosition?: TooltipPosition,
  onClose?: * => any,
  children: Node,
  ignoreRefs?: {
    current: Array<{
      current: null | ElementRef<any>
    }>
  },
  theme: TooltipThemeType,
  rest?: any,
|};
*/

var Tooltip = function Tooltip(_ref
/*: Props */
) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return undefined;
  } : _ref$onClose,
      children = _ref.children,
      _ref$tooltipPosition = _ref.tooltipPosition,
      tooltipPosition = _ref$tooltipPosition === void 0 ? 'bottom' : _ref$tooltipPosition,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      _ref$ignoreRefs = _ref.ignoreRefs,
      ignoreRefs = _ref$ignoreRefs === void 0 ? {} : _ref$ignoreRefs,
      rest = _objectWithoutPropertiesLoose(_ref, ["visible", "onClose", "children", "tooltipPosition", "theme", "ignoreRefs"]);

  var node = useRef();

  var _useDimensionsDetecto = useDimensionsDetector(node),
      height = _useDimensionsDetecto.height,
      width = _useDimensionsDetecto.width;

  useClickOutsideCallback(node, function (e) {
    var ignoreClickOutside = ignoreRefs && ignoreRefs.current && ignoreRefs.current.some(function (ref) {
      return ref && ref.current && ref.current.contains(e.target);
    });
    if (ignoreClickOutside) return;
    onClose(e);
  }, [visible, onClose]);
  /* To mitigate flickering if tooltip is initially visible */

  var _useState = useState(false),
      initiallyVisible = _useState[0],
      setInitiallyVisible = _useState[1];

  useEffect(function () {
    setTimeout(function () {
      setInitiallyVisible(true);
    }, 50);
  }, []);
  return /*#__PURE__*/React.createElement(theme.TransparentOffset, {
    ref: node,
    tooltipHeight: height + 15,
    tooltipWidth: width + 15,
    tooltipPosition: tooltipPosition,
    initiallyVisible: initiallyVisible,
    visible: visible,
    "data-test": "tooltip"
  }, /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    "data-test": "info-bubble-main",
    tooltipPosition: tooltipPosition,
    theme: theme
  }, rest), children));
};

export default Tooltip;